export enum EventUserInviteStatus {
  Invited = 0,
  Accepted = 1,
  Declined = 2,
  Attended = 3,
}
